import React from "react";
import styles from "../modules/Services.module.css";

const Services = () => {
  const services = [
    {
      id: 1,
      title: "Education & E-Learning Solutions",
      icon: "/logo-9.png", // replace with your education icon
      desc:
        "We build software and websites tailored for schools, colleges, and training institutes.",
      offers: [
        "Student Management Systems (attendance, grades, fees)",
        "Online Class Portals & Learning Platforms",
        "Admission Management Dashboards",
        "Data Analytics for Student Performance",
      ],
    },
    {
      id: 2,
      title: "Hospital & Clinic Management Systems",
      icon: "/logo-8.png",
      desc:
        "For healthcare organizations seeking smoother operations and better patient care.",
      offers: [
        "Appointment Booking & Patient Record Systems",
        "Billing & Prescription Management",
        "Doctor & Staff Scheduling Tools",
        "Secure Data Storage and Access Control (cloud & offline)",
      ],
    },
    {
      id: 3,
      title: "Café & Restaurant Management",
      icon: "/logo-7.png",
      desc:
        "For cafes, restaurants, and food chains that want efficiency and clarity in their daily operations.",
      offers: [
        "Billing Systems",
        "Menu & Order Management",
        "Table & Reservation Systems",
        "Inventory & Stock Tracking",
        "Daily Sales Reports",
      ],
    },
    {
      id: 4,
      title: "Retail & Inventory Management",
      icon: "/logo-11.png",
      desc:
        "Custom tools for shops, distributors, and small warehouses to manage stock effortlessly.",
      offers: [
        "Inventory Control & Barcode Integration",
        "Vendor and Purchase Management",
        "Sales & Expense Tracking",
        "Stock Reorder Alerts",
        "Analytics for Profit & Loss Visualization",
      ],
    },
    {
      id: 5,
      title: "Small Business Solutions",
      icon: "/logo-12.png",
      desc:
        "We support local entrepreneurs and startups with simple, cost-effective digital tools.",
      offers: [
        "Business Websites & Online Portfolios",
        "Billing & Invoicing Software",
        "Client Database Systems",
        "Marketing Dashboards",
        "Analytics & Reports",
      ],
    },
    {
      id: 6,
      title: "Video Production & Editing",
      icon: "/logo-10.png",
      desc: "Because visual storytelling drives attention and trust.",
      offers: [
        "Corporate Promo Videos",
        "Product Showcases & Advertisements",
        "Animated Explainer Videos",
        "Editing & Post-Production Services",
        "Logo Animation and Branding Reels",
      ],
    },
  ];

  return (
    <div className={styles.servicesContainer}>
      <h1 className={styles.pageTitle}>Our Services</h1>
      <p className={styles.pageSubtitle}>
        Innovative and affordable digital solutions designed for every industry.
      </p>

      <div className={styles.servicesGrid}>
        {services.map((service) => (
          <div className={styles.serviceCard} key={service.id}>
            <img src={service.icon} alt={service.title} className={styles.icon} />
            <h2>{service.title}</h2>
            <p className={styles.desc} style={{ marginTop: service.id === 3 ? "3.7rem" : "0rem" ,marginBottom: service.id === 6 ? "2.7rem" : "1.5rem" }}>{service.desc}</p>
            <h3>What We Offer</h3>
            <ul style={{ marginLeft: service.id === 3 ? "3rem" : "2rem",}}>
              {service.offers.map((item, index) => (
                <li key={index}>• {item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      {/* FOOTER */}
      <footer className={styles.footer}>
        <p>© 2024 Shonix Solutions. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Services;

